<template>
  <div class="nav" :class="{'nav-show':visible}" id="nav">
    <img
      src="https://summit-img.geekpark.net/r2020/pc_rebuild2020.svg"
      style="width: 3vh"
      class="ifx"
      @click="scrollToTop"
    />
    <div class="navs-container">
      <!-- <a class="nav_item_a nav_item_link" href="#p2">
        <img
          alt
          src="https://summit-img.geekpark.net/r2020/pc_nav_guest.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/r2020/pc_nav_guest_selected.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/r2020/pc_nav_guest.svg';"
        />
      </a> -->
      <a class="nav_item_a nav_item_link" href="#datePlan">
        <img
          alt
          src="https://summit-img.geekpark.net/r2020/pc_nav_date.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/r2020/pc_nav_date_selected.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/r2020/pc_nav_date.svg';"
        />
      </a>
      <a class="nav_item_a nav_item_link" href="#concat">
        <img
          alt
          src="https://summit-img.geekpark.net/r2020/pc_nav_concat.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/r2020/pc_nav_concat_selected.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/r2020/pc_nav_concat.svg';"
        />
      </a>
      <a class="last_rebuild_wrapper nav_item_a">
        <img
          class="last_rebuild_img"
          alt
          src="https://summit-img.geekpark.net/r2020/pc_nav_last.svg"
          onmouseover="this.src='https://summit-img.geekpark.net/r2020/pc_nav_last_selected.svg';"
          onmouseout="this.src='https://summit-img.geekpark.net/r2020/pc_nav_last.svg';"
        />
        <div class="last_rebuild_list" id="nav_last_rebuild_list">
          <img
            class="year_list_bg"
            alt
            src="https://summit-img.geekpark.net/r2020/pc_nav_last_wrapper.svg"
          />
          <div class="year_list_wrapper">
            <a class="year_item" href="http://r2019.geekpark.net/" target="_blank">
              <img
                onmouseover="this.src='https://summit-img.geekpark.net/r2020/year_2019_selected.svg';"
                onmouseout="this.src='https://summit-img.geekpark.net/r2020/year_2019.svg';"
                src="https://summit-img.geekpark.net/r2020/year_2019.svg"
              />
            </a>
            <a class="year_item" href="http://r2018.geekpark.net/" target="_blank">
              <img
                onmouseover="this.src='https://summit-img.geekpark.net/r2020/year_2018_selected.svg';"
                onmouseout="this.src='https://summit-img.geekpark.net/r2020/year_2018.svg';"
                src="https://summit-img.geekpark.net/r2020/year_2018.svg"
              />
            </a>
            <a class="year_item" href="http://r2017.geekpark.net/" target="_blank">
              <img
                onmouseover="this.src='https://summit-img.geekpark.net/r2020/year_2017_selected.svg';"
                onmouseout="this.src='https://summit-img.geekpark.net/r2020/year_2017.svg';"
                src="https://summit-img.geekpark.net/r2020/year_2017.svg"
              />
            </a>
            <a class="year_item" href="http://r2016.geekpark.net/" target="_blank">
              <img
                onmouseover="this.src='https://summit-img.geekpark.net/r2020/year_2016_selected.svg';"
                onmouseout="this.src='https://summit-img.geekpark.net/r2020/year_2016.svg';"
                src="https://summit-img.geekpark.net/r2020/year_2016.svg"
              />
            </a>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  props: ["visible"],
  methods: {
    scrollToTop() {
      window.scrollTo({ behavior: "smooth", top: 0 });
    }
  }
};
</script>

<style scoped lang="less">
.nav {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 5vh 0 3vh 0;
  width: 8.5vh;
  height: 100vh;
  position: fixed;
  left: -8.5vh;
  top: 0;
  border-right: 1px solid #9b9b9b;
  background: #fff;
  z-index: 2000;
  transition: all 0.5s;
}

.nav-show {
  left: 0;
}

.ifx:hover {
  cursor: pointer;
}

.navs-container {
  display: flex;
  flex-direction: column;

  .nav_item_a {
    display: block;
    padding: 2vh 0;
    width: 2vh;
    &:hover {
      cursor: pointer;
    }
    &:not(:first-of-type) {
      border-top: 2px solid #0023fc;
    }

    img {
      width: 2vh;
    }
  }
}

.last_rebuild_wrapper {
  position: relative;
  &:hover {
    .last_rebuild_list {
      display: block;
    }
  }
  .last_rebuild_list {
    position: absolute;
    top: -20vh;
    left: 2vh;
    padding-left: 1vh;
    display: none;
    &.last_rebuild_list_none {
      display: none;
    }
    .year_list_bg {
      height: 34vh;
      width: auto;
    }
    .year_list_wrapper {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 5.2vh 4vh 4vh 9vh;
      .year_item {
        display: block;
        margin-bottom: 2vh;
      }
      img {
        height: 4vh;
        width: auto;
      }
    }
  }
}
</style>
